import { Button, TextField } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { isValidSalesAppBaseUrl, normalizeSalesAppBaseUrl } from '../../utils/ParamConfigUtils';
import ReduxLanguage from '../ReduxLanguage';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: 20,
    maxWidth: 480,
  },
  inputTitle: {
    marginTop: 0,
    marginBottom: 8,
    fontSize: 18,
    fontWeight: 'bold',
  },
  description: {
    marginBottom: 16,
    color: 'gray',
  },
  errorText: {
    color: 'red',
    marginTop: 8,
  },
});

export interface ISalesAppVersionParamConfigFormState {
  value: string;
  valueError: boolean;
}

export interface ISalesAppVersionParamConfigFormProps extends WithStyles<typeof styles> {
  initialValue: string;
  hasExistingConfig: boolean;
  onSave: (value: string) => void;
  isSaving: boolean;
}

class SalesAppVersionParamConfigForm extends React.Component<ISalesAppVersionParamConfigFormProps, ISalesAppVersionParamConfigFormState> {

  constructor(props: ISalesAppVersionParamConfigFormProps) {
    super(props);
    this.state = {
      value: props.initialValue || '',
      valueError: false,
    };
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps: ISalesAppVersionParamConfigFormProps) {
    const { initialValue } = this.props;
    if (prevProps.initialValue !== initialValue) {
      this.setState({ value: initialValue || '', valueError: false });
    }
  }

  onChangeValue(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ value, valueError: !isValidSalesAppBaseUrl(value) });
  }

  canSubmitForm() {
    const { value, valueError } = this.state;
    const { initialValue, isSaving, hasExistingConfig } = this.props;
    const normalizedValue = normalizeSalesAppBaseUrl(value);
    const normalizedInitialValue = normalizeSalesAppBaseUrl(initialValue);
    const isValid = !isSaving && !valueError && isValidSalesAppBaseUrl(value);
    if (!hasExistingConfig) {
      return isValid;
    }
    return isValid && normalizedValue !== normalizedInitialValue;
  }

  onSubmit() {
    const { onSave } = this.props;
    const { value } = this.state;
    if (this.canSubmitForm()) {
      onSave(normalizeSalesAppBaseUrl(value));
    }
  }

  render() {
    const { classes, isSaving } = this.props;
    const { value, valueError } = this.state;

    return (
      <div className={classes.container}>
        <h3 className={classes.inputTitle}>
          <ReduxLanguage languageKey="settings.salesAppVersion" />
        </h3>
        <p className={classes.description}>
          <ReduxLanguage languageKey="settings.salesAppVersionDescription" />
        </p>
        <TextField
          value={value}
          onChange={this.onChangeValue}
          fullWidth
          variant="outlined"
          placeholder="https://sales-apps.sofialocks.cloud/launchpad"
        />
        {valueError && (
          <p className={classes.errorText}>
            <ReduxLanguage languageKey="settings.invalidValue" />
          </p>
        )}
        <Button
          style={{ marginTop: 20 }}
          variant="contained"
          color="primary"
          disabled={!this.canSubmitForm()}
          onClick={this.onSubmit}
        >
          <ReduxLanguage languageKey="settings.save" />
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(SalesAppVersionParamConfigForm);
